module.exports = __webpack_public_path__ + "static/media/add_green_circle.283901dc.svg";